import { Toast } from "primereact/toast";
import { useRef, useState } from "react";
import { IEndClientMast } from "../../models/EndClientMast";
import { EmptyEndClient } from "./EmptyEndClient";
import { Form } from "./Form";
import { Table } from "./Table";
import { IPermissionProps } from "../../models/Login";

export interface IModel {
    open: boolean,
    singleData: IEndClientMast
}

export const EndClientMast = (permissions: IPermissionProps) => {

    const [modal, setModal] = useState({ singleData: EmptyEndClient, open: false } as IModel);
    const [reload, setReload] = useState(false);
    const toast = useRef<any>(null);

    const hideDialog = () => {
        setModal({ singleData: EmptyEndClient, open: false })
    };

    return (
        <>
            <Table permissions={permissions} setModal={setModal} toast={toast} reload={reload}></Table>
            <Form singleData={modal.singleData} open={modal.open} hideDialog={hideDialog} toast={toast} reload={reload} setReload={setReload}></Form>

            <Toast ref={toast} />
        </>
    );
}
